const { default: axiosIns } = require('@/libs/axios')

const DailyCostsService = {

  async getDailyCosts(filter) {
    return axiosIns.post('/admin/dailycosts', filter)
      .then(response => response.data)
  },
  async exportCsv(data) {
    return axiosIns.post('/admin/dailycosts/export/csv', data, { responseType: 'blob' })
      .then(response => response.data)
  },
  async exportExcel(data) {
    return axiosIns.post('/admin/dailycosts/export/excel', data, { responseType: 'blob' })
      .then(response => response.data)
  },
}
export default DailyCostsService
